import { type ReactElement } from 'react';
import { useShow } from '@refinedev/core';
import { Show } from '@refinedev/antd';
import { Descriptions, Tag, Grid, Typography } from 'antd';

import type { AdminRecoveryEvent } from '@/types';

import { RECOVERY_KIND_COLORS, RECOVERY_KIND_LABELS } from './recoveryKindMeta';

const { useBreakpoint } = Grid;
const { Paragraph } = Typography;

export function RecoveryEventShow(): ReactElement {
  const { query } = useShow<AdminRecoveryEvent>();
  const record = query.data?.data;
  const isLoading = query.isLoading;

  const screens = useBreakpoint();
  const descColumns = screens.md ? 2 : 1;

  return (
    <Show isLoading={isLoading}>
      {record && (
        <>
          <Descriptions bordered column={descColumns} size="small">
            <Descriptions.Item label="ID">{record.id}</Descriptions.Item>

            <Descriptions.Item label="Recovery Kind">
              <Tag
                color={RECOVERY_KIND_COLORS[record.recoveryKind] ?? 'default'}
              >
                {RECOVERY_KIND_LABELS[record.recoveryKind] ??
                  record.recoveryKind}
              </Tag>
            </Descriptions.Item>

            <Descriptions.Item label="Order">
              <a href={`/orders/show/${record.orderId}`}>{record.orderId}</a>
            </Descriptions.Item>

            <Descriptions.Item label="Thread ID">
              {record.threadId || '—'}
            </Descriptions.Item>

            <Descriptions.Item label="Created At">
              {new Date(record.createdAt).toLocaleString()}
            </Descriptions.Item>
          </Descriptions>

          <Typography.Title level={5} style={{ marginTop: 24 }}>
            Details
          </Typography.Title>
          <Paragraph>
            <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
              {JSON.stringify(record.details, null, 2)}
            </pre>
          </Paragraph>
        </>
      )}
    </Show>
  );
}
